import type { AgentRecordContext } from '@cdf/api-client-react';
import type { PromptLibraryContext } from './prompt-library-context';

/** Labels and UI hints come from the authorized native host. The API rechecks every operation. */
export interface SharedAgentRecord {
  context: AgentRecordContext;
  label: string;
  canWrite: boolean;
  canAdminister?: boolean;
  threadId?: string;
  prompts: PromptLibraryContext;
  starterQuestions?: readonly string[];
  threadTitles?: readonly string[];
  hideRecordId?: boolean;
  onThreadChange?: (id: string | undefined) => void;
}
export function sharedContextParams(context: AgentRecordContext) {
  return { tenantId: context.tenantId, entityId: context.entityId, contextKind: context.kind, recordId: context.recordId };
}
export function sharedContextKey(identity: string, context: AgentRecordContext, threadId?: string) {
  return JSON.stringify([identity, context.tenantId, context.entityId, context.kind, context.recordId, threadId ?? '']);
}
export function sameSharedContext(a: AgentRecordContext | undefined, b: AgentRecordContext) {
  return Boolean(a && a.kind === b.kind && a.tenantId === b.tenantId && a.entityId === b.entityId && a.recordId === b.recordId);
}
